import React from 'react';
import TestingContainer from '@src/containers/Testing';
import { PERMISSIONS } from '@src/constants';
import PermissionGate from '@src/components/PermissionGate';

const Testing = () => (
  <PermissionGate requiredPermissions={[PERMISSIONS.TEST_FLOW]}>
    <TestingContainer />
  </PermissionGate>
);

export default Testing;
